import DroppableWrapper from './DroppableWrapper';

export default DroppableWrapper;
